import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../api';
import { useAuth } from '../context/AuthContext';
import { Icon } from '../components/common/Icons';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.username || !form.password) {
      setError('Please provide both username and password');
      return;
    }
    setLoading(true);
    try {
      const { data } = await authApi.login(form);
      login(data.user, data.accessToken);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message ?? 'Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-glow-orb" />
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">
            <Icon name="note" size={22} />
          </div>
          <span className="auth-logo-text">Memora</span>
        </div>

        <h1 className="auth-title">Welcome back</h1>
        <p className="auth-subtitle">Sign in to your note intelligence workspace</p>

        {error && (
          <div className="alert-custom error">
            <Icon name="close" size={14} />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label className="form-label" htmlFor="login-username">Username</label>
            <div className="input-with-icon-wrap">
              <Icon name="user" size={16} className="input-leading-icon" />
              <input
                id="login-username"
                className="form-input with-leading-icon"
                value={form.username}
                onChange={set('username')}
                placeholder="your_username"
                autoComplete="username"
                autoFocus
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="login-password">Password</label>
            <div className="input-with-icon-wrap">
              <Icon name="shield" size={16} className="input-leading-icon" />
              <input
                id="login-password"
                className="form-input with-leading-icon with-trailing-btn"
                type={showPassword ? 'text' : 'password'}
                value={form.password}
                onChange={set('password')}
                placeholder="••••••••"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="input-trailing-btn"
                onClick={() => setShowPassword(!showPassword)}
                title={showPassword ? 'Hide password' : 'Show password'}
                aria-label="Toggle password visibility"
              >
                <Icon name="eye" size={16} />
              </button>
            </div>
          </div>

          <button
            className="btn-primary-custom auth-submit-btn"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="spinner sm" />
                <span>Signing in...</span>
              </>
            ) : (
              <>
                <span>Sign In to Memora</span>
                <Icon name="arrow-right" size={16} />
              </>
            )}
          </button>
        </form>

        <div className="auth-footer-prompt">
          Don't have an account yet?{' '}
          <Link to="/signup" className="auth-link">
            Create an account
          </Link>
        </div>
      </div>
    </div>
  );
}
